module.exports = __webpack_public_path__ + "img/microfone.8f512392.png";